(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsController', TabFleetsController);

    TabFleetsController.$inject = ['$scope', '$state', 'TabFleets', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function TabFleetsController ($scope, $state, TabFleets, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.applyFilter = applyFilter;
        vm.loadPage = loadPage;
        vm.predicates = pagingParams.predicates;
        vm.transition = transition;
        vm.currentState = "tab-fleets";
        vm.currentStateFilter = "tab-fleets-filter";
        vm.objectClazz = pagingParams.objectClazz;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null") {
            vm.predicates = JSON.parse(retrievedOrder);
        }
        var filter = localStorage.getItem(vm.currentStateFilter);

        //Aggiunta per impaginazione
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        if (filter !== null && filter !== "null" && filter !== undefined) {
            filter = JSON.parse(filter);
            if (Object.keys(filter).length > 0) {
                vm.objectClazz = filter.objectClazz;
            }
        }

       vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort()
            };

            TabFleets.query(body, onSuccess, onError);
            // addFilter(body);
            // TabFleets.filterClass(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tabFleets = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function applyFilter(objClass) {
            var filter = {};
            filter.objectClazz = vm.objectClazz = objClass;
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(filter));
            vm.loadAll();
        }

        function addFilter(body) {
            if (+vm.objectClazz.id !== -1) {
                body.objectClazzId = vm.objectClazz.id;
            }
        }

        function transition (notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll();

    }
})();
